import { MigrationInterface, QueryRunner } from 'typeorm'
import { Domain, getRepository } from '@things-factory/shell'
import { KpiOrgScope } from '../service/kpi-org-scope/kpi-org-scope'
import * as fs from 'fs'
import * as path from 'path'

interface KpiOrgScopeSeedData {
  org: string
  scope01?: string
  scope02?: string
  scope03?: string
  scope04?: string
  scope05?: string
  name?: string
  entityType?: string
  entityId?: string
  entityName?: string
}

export class SeedKpiOrgScope1752192090128 implements MigrationInterface {
  name = 'SeedKpiOrgScope1752192090128'

  public async up(queryRunner: QueryRunner): Promise<void> {
    try {
      const repository = getRepository(KpiOrgScope)
      const domainRepository = getRepository(Domain)

      // SYSTEM 도메인 확인
      const domain: Domain = await domainRepository.findOneBy({ name: 'SYSTEM' })
      if (!domain) {
        console.log('❌ SYSTEM domain not found')
        return
      }

      // JSON 파일 읽기
      const seedFilePath = path.join(__dirname, 'seed-data', 'kpi-org-scope-seed.json')
      const seedData: KpiOrgScopeSeedData[] = JSON.parse(fs.readFileSync(seedFilePath, 'utf8'))

      console.log(`🏗️  Processing ${seedData.length} KPI org-scope mappings from JSON seed`)

      for (const orgScopeData of seedData) {
        try {
          // entityType과 entityId가 있으면 사용, 없으면 기본값 설정
          const entityType = orgScopeData.entityType || 'Project'
          const entityId = orgScopeData.entityId || `project-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
          const entityName = orgScopeData.entityName || orgScopeData.name || orgScopeData.org

          const existingOrgScope = await repository.findOne({
            where: { 
              entityType, 
              entityId,
              domain: { id: domain.id } 
            }
          })

          if (existingOrgScope) {
            console.log(`⚠️  KPI Org-Scope already exists: ${orgScopeData.org}`)
            continue
          }

          const orgScope = await repository.save({
            entityType,
            entityId,
            entityName,
            org: orgScopeData.org, // legacy field
            scope01: orgScopeData.scope01,
            scope02: orgScopeData.scope02,
            scope03: orgScopeData.scope03,
            scope04: orgScopeData.scope04,
            scope05: orgScopeData.scope05,
            domain
          })

          console.log(`✅ Created KPI Org-Scope: ${orgScope.entityName} [${orgScope.entityType}:${orgScope.entityId}] (${orgScope.scope01})`)
        } catch (error) {
          console.error(`❌ Error creating KPI Org-Scope "${orgScopeData.org}":`, error)
        }
      }

      console.log(`🎉 Successfully processed KPI org-scope mappings from JSON seed`)
    } catch (error) {
      console.error('❌ Error seeding KPI org-scope mappings from JSON:', error)
      throw error
    }
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    try {
      const repository = getRepository(KpiOrgScope)
      const domainRepository = getRepository(Domain)

      const domain: Domain = await domainRepository.findOneBy({ name: 'SYSTEM' })
      if (!domain) {
        console.log('⚠️  SYSTEM domain not found. Nothing to delete.')
        return
      }

      // JSON 파일 읽기
      const seedFilePath = path.join(__dirname, 'seed-data', 'kpi-org-scope-seed.json')
      const seedData: KpiOrgScopeSeedData[] = JSON.parse(fs.readFileSync(seedFilePath, 'utf8'))

      console.log(`🗑️  Cleaning up ${seedData.length} KPI org-scope mappings`)

      for (const orgScopeData of seedData.reverse()) {
        try {
          const entityType = orgScopeData.entityType || 'Project'
          const entityId = orgScopeData.entityId || `project-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

          const orgScope = await repository.findOne({
            where: { 
              entityType, 
              entityId,
              domain: { id: domain.id } 
            }
          })

          if (orgScope) {
            await repository.delete(orgScope.id)
            console.log(`✅ Deleted KPI Org-Scope: ${orgScopeData.org}`)
          }
        } catch (error) {
          console.error(`❌ Error deleting KPI Org-Scope "${orgScopeData.org}":`, error)
        }
      }

      console.log(`🎉 Successfully cleaned up KPI org-scope mappings`)
    } catch (error) {
      console.error('❌ Error cleaning up KPI org-scope mappings:', error)
      throw error
    }
  }
}
